/** Matches `isDesktop` in `src/styles/mixins.scss` (min-width: 960px). */
export const COOKIE_BANNER_DESKTOP_MEDIA_QUERY = '(min-width: 960px)';
